import * as React from "react";
import clsx from "clsx";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { SnapshotGridTab } from "@/modules/snapshots/grid/types";

interface Props {
  activeTab: SnapshotGridTab;
  onActiveTabChange: (tab: SnapshotGridTab) => void;
  showDashboard: boolean;
  savedPivotCount: number;
  hidden: boolean;
}

export const SnapshotGridTabs: React.FC<Props> = ({
  activeTab,
  onActiveTabChange,
  showDashboard,
  savedPivotCount,
  hidden,
}) => (
  <Tabs
    value={activeTab}
    onValueChange={value => onActiveTabChange(value as SnapshotGridTab)}
    className={clsx("mb-2", hidden && "hidden")}
  >
    <TabsList className="bg-[#f1edea]">
      <TabsTrigger value="table">Table</TabsTrigger>
      {showDashboard && (
        <TabsTrigger value="dashboard">Dashboard{savedPivotCount > 0 ? ` (${savedPivotCount})` : ""}</TabsTrigger>
      )}
    </TabsList>
  </Tabs>
);
